export const SMS_CODES = {
  C003: 'C003',
  C004: 'C004',
  C005: 'C005',
  C006: 'C006',
  C008: 'C008',
  C013: 'C013',
  C017: 'C017',
  C021: 'C021',
  C024: 'C024',
  C025: 'C025',
  C032: 'C032',
  C037: 'C037',
  C038: 'C038',
  C039: 'C039',
  C040: 'C040',
  C041: 'C041',
  C045: 'C045',
  C047: 'C047',
  C048: 'C048',
  C049: 'C049',
  C050: 'C050'
}
